import React from 'react'

import Select from 'Components/Select'

export default React.memo(props =>
  <Select style={props.style}
          inline={props.inline}
          inlineWidth={props.inlineWidth}
          title={props.title}
          disabled={props.disabled || false}
          options={props.options}
          name={props.name}
          onChange={props.onChange}
          inputStyle={props.inputStyle || { padding: 0 }}
          value={props.infoTiers === true && props.data !== undefined ? props.data.id : props.data}/>
)




// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/ComboSimple.js